"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5z"
}), 'NorthWestSharp');